import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import { useUser } from "./UserContext";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
    const navigate = useNavigate();
    const { user } = useUser();

    const [isCoursesDropdownOpen, setCoursesDropdownOpen] = useState(false);
    const [isAchievementsDropdownOpen, setAchievementsDropdownOpen] = useState(false);
    const [hoverTimeout, setHoverTimeout] = useState(null);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isJobDropdownOpen, setJobDropdownOpen] = useState(false);
    const handleMouseEnter = (setDropdownOpen) => {
        if (hoverTimeout) clearTimeout(hoverTimeout);
        setDropdownOpen(true);
    };

    const handleMouseLeave = (setDropdownOpen) => {
        setHoverTimeout(setTimeout(() => {
            setDropdownOpen(false);
        })); // 200ms delay
    };

    const coursesLinks = [
        { path: "/programs/online", name: "Online Courses" },
        // { path: "/courses/summer-2024", name: "Summer 2024" },
       // { path: "/programs/fllSummerCamp", name: "Aerial Drone Course" },
        { path: "/programs/SummerCourse", name: "2025 Summer Course" },
        { path: "/programs/ScienceFair", name: "Science Fair Preparation Course" },
        { path: "/programs/iqWorkshop", name: "IQ Workshop" },
        { path: "/programs/roboticsWorkshops", name: "Robotics & STEM Workshops" },
        { path: "/programs/speakup", name: "Speak up! Workshop" },
      //  { path: "/programs/virtualskills", name: "Virtual Skills Summer Camp" },
    ];
    
    const achievementsLinks = [
        { path: "/teams/timeline", name: "Timeline" },
        { path: "/teams", name: "Achievements" },
    ];
    const menuLinks = [
        { path: "/", name: "Home" },
        { path: "https://2055vrc.live/", name: "Blog" },
        ...coursesLinks,
        ...achievementsLinks,
        { path: "/store", name: "Store" },
        { path: "/donation", name: "Donate" },
        user ? { path: "/profile", name: "Profile" } : { path: "/login", name: "Login" },
    ];

    console.log(user)

    return (
        <nav className="font-mono border-gray-200 bg-gray-900 sticky top-0 z-30">
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-2">
                <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                    <img src={logo} alt="Mi3L Schools" className="w-20 h-13 flex p-0" />
                    <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">Mi3L School</span>
                </Link>
                <button
                    onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                    className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    aria-controls="navbar-default"
                    aria-expanded={isMobileMenuOpen}
                > <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
        </button>
                {isMobileMenuOpen && (
                <div className={`w-full md:block md:w-auto ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
                <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 bg-gray-900 border-gray-900">
                    {menuLinks.map((link, index) => (
                        link.path.startsWith('http') ? (
                            <li key={index}>
                                <a href={link.path} className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent">
                                    {link.name}
                                </a>
                            </li>
                        ) : (
                            <li >
                                <button
                                    onClick={() => {navigate(link.path); setMobileMenuOpen(false)}}
                                    className="w-full text-left text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent"
                                >
                                    {link.name}
                                    
                                </button>
                                
                            </li>
                        )
                    ))}
                </ul>
            </div>)}
                <div className="hidden w-full md:block md:w-auto" id="navbar-default">
                    <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 bg-gray-900 border-gray-900">
                        {/* <li>
                            <a href="https://2055vrc.live/" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent" aria-current="page">Blog</a>
                        </li> */}
                        <li 
                            onMouseEnter={() => handleMouseEnter(setAchievementsDropdownOpen)} 
                            onMouseLeave={() => handleMouseLeave(setAchievementsDropdownOpen)} 
                            className="relative"
                        >
                            <Link to="/about" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent">
                            About
                            <svg className="w-4 h-4 ml-1 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                            </svg>
                            </Link>
                            {isAchievementsDropdownOpen && (
                                <ul 
                                    className="absolute top-full left-0 mt-0 w-48 border border-gray-200 rounded-md shadow-lg bg-gray-800 border-gray-700 z-50"
                                    onMouseEnter={() => handleMouseEnter(setAchievementsDropdownOpen)}
                                    onMouseLeave={() => handleMouseLeave(setAchievementsDropdownOpen)}
                                >
                                    <li><Link to="/contact" className="block px-4 py-2 text-gray-900 hover:bg-gray-100 text-white hover:bg-gray-700">About Us</Link></li>
                                    <li><Link to="/teams/timeline" className="block px-4 py-2 text-gray-900 hover:bg-gray-100 text-white hover:bg-gray-700">History</Link></li>
                                    <li><Link to="/teams" className="block px-4 py-2 text-gray-900 hover:bg-gray-100 text-white hover:bg-gray-700">Achievements</Link></li>
                                </ul>
                            )}
                        </li>
                        <li 
                            onMouseEnter={() => handleMouseEnter(setCoursesDropdownOpen)} 
                            onMouseLeave={() => handleMouseLeave(setCoursesDropdownOpen)} 
                            className="relative"
                        >
                            <Link to="/programs" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent">
                            Programs
                            <svg className="w-4 h-4 ml-1 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                            </svg>
                            </Link>
                            {isCoursesDropdownOpen && (
                                <ul 
                                    className="absolute top-full left-0 mt-0 w-48 border border-gray-200 rounded-md shadow-lg bg-gray-800 border-gray-700 z-50"
                                    onMouseEnter={() => handleMouseEnter(setCoursesDropdownOpen)}
                                    onMouseLeave={() => handleMouseLeave(setCoursesDropdownOpen)}
                                >
                                      {/* Course submenu */}
                            <li className="relative group">
                                <span className="block px-4 py-2 text-white cursor-pointer group-hover:bg-gray-700">
                                    Courses
                                <svg className="w-3 h-3 ml-1 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
                                </span>
                            <ul className="absolute left-full top-0 mt-0 w-48 bg-gray-800 border border-gray-700 rounded-md shadow-lg z-50 hidden group-hover:block">
                                <li><Link to="/programs/online" className="block px-4 py-2 text-white hover:bg-gray-700">Online Courses</Link></li>
                                <li><Link to="/programs/SummerCourse" className="block px-4 py-2 text-white hover:bg-gray-700">2025 Summer Course</Link></li>
                                <li><Link to="/programs/ScienceFair" className="block px-4 py-2 text-white hover:bg-gray-700">Science Fair Preparation Course</Link></li>
                            </ul>
                            </li>
                                {/* Workshop submenu */}
                                  <li className="relative group">
                            <span className="block px-4 py-2 text-white cursor-pointer group-hover:bg-gray-700">
                                Workshops
                                <svg className="w-3 h-3 ml-1 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
                            </span>
                                <ul className="absolute left-full top-0 mt-0 w-48 bg-gray-800 border border-gray-700 rounded-md shadow-lg z-50 hidden group-hover:block">
                                    <li><Link to="/programs/iqWorkshop" className="block px-4 py-2 text-white hover:bg-gray-700">IQ Summer Workshop</Link></li>
                                    <li><Link to="/programs/speakup" className="block px-4 py-2 text-white hover:bg-gray-700">Speak up! Workshop</Link></li>
                                    <li><Link to="/programs/roboticsWorkshops" className="block px-4 py-2 text-white hover:bg-gray-700">Robotics & STEM Workshops</Link></li>
                                </ul>
                            </li>
            {/* Camp submenu */}
                        <li className="relative group">
                            <span className="block px-4 py-2 text-white cursor-pointer group-hover:bg-gray-700">
                            Camps
                            <svg className="w-3 h-3 ml-1 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
                            </span>
                            <ul className="absolute left-full top-0 mt-0 w-48 bg-gray-800 border border-gray-700 rounded-md shadow-lg z-50 hidden group-hover:block">
                                <li><Link to="/programs/fllSummerCamp" className="block px-4 py-2 text-white hover:bg-gray-700">FLL Robotics Summer Camp</Link></li>
                                <li><Link to="/programs/virtualskills" className="block px-4 py-2 text-white hover:bg-gray-700">Virtual Skills Summer Camp</Link></li>
                            </ul>
                        </li>
                             
                                </ul>
                            )}
                        </li>
                        
                    
                        <li>
                            <Link to="/store" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent" aria-current="page">Store</Link>
                        </li>
                        <li>
                            <Link to="/donation" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent" aria-current="page">Donate</Link>
                        </li>
                        <li
  onMouseEnter={() => handleMouseEnter(setJobDropdownOpen)}
  onMouseLeave={() => handleMouseLeave(setJobDropdownOpen)}
  className="relative"
>
  <span className="text-xl block py-2 px-3 text-gray-900 rounded cursor-pointer hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent">
    Job
    <svg className="w-4 h-4 ml-1 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
    </svg>
  </span>
  {isJobDropdownOpen && (
    <ul className="absolute top-full left-0 mt-0 w-48 border border-gray-200 rounded-md shadow-lg bg-gray-800 border-gray-700 z-50">
      <li>
        <Link to="/volunteer" className="block px-4 py-2 text-white hover:bg-gray-700">
          Volunteer
        </Link>
      </li>
      {/* Add more job-related submenu items here if needed */}
    </ul>
  )}
</li>
                       {user && <li>
                            <Link to="/profile" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent" aria-current="page">Profile</Link>
                        </li>}
                        {!user && <li>
                            <Link to="/login" className="text-xl block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-700 md:p-0 text-white md:hover:text-orange-500 hover:bg-gray-700 hover:text-white md:hover:bg-transparent" aria-current="page">Login</Link>
                        </li>}
                    </ul>
                </div>
            </div>
        </nav>
    );
}
